import { Component, OnInit , AfterViewInit, ViewChild} from '@angular/core';
declare var $: any;
import { DataTableDirective } from 'angular-datatables';


@Component({
  selector: 'app-salse-quotation-grid',
  templateUrl: './salse-quotation-grid.component.html',
  styleUrls: ['./salse-quotation-grid.component.css']
})
export class SalseQuotationGridComponent implements OnInit {

  
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  title="Quotations";
  dtOptions: any = {};
  constructor() { }

  ngOnInit() : void {
    this.dtOptions = {
      dom: 'lBfrtip',
      lengthMenu: [[5, 10, 20, -1], [5, 10, 20, "All"]],
      scroll: "250px",
      select: true,
      buttons: [
        {
          extend: 'collection',
          text: 'Export',
          buttons: ['copy', 'csv', 'excel', 'pdf', 'print',]
        },
        { extend: 'colvis', text: 'Column Visibility', classname: 'btn btn-primary' }
      ],
    }
  }
  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.columns().every(function () {
        const that = this;
        $('input', this.footer()).on('keyup change', function () {
          if (that.search() !== this['value']) {
            that
              .search(this['value'])
              .draw();
          }
        });
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/sales-orders/sales-quotation/salse-quotation-grid/salse-quotation-grid.component.ts